import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { GISGO_AUTH_CONTEXT } from './auth-context';
import { StaffRole } from './staff';

/**
 * Gate RBAC par écran. `admin` passe toujours (il porte toutes les
 * approbations — décision umbrella §10). Sans rôle → refus.
 *
 * NB : le RBAC produit est « visible, pas masqué » (spec design §4) —
 * ce guard protège la route ; au niveau des actions, on désactive
 * les boutons avec explication plutôt que de les cacher.
 */
export function staffRoleGuard(...allowed: StaffRole[]): CanActivateFn {
  return () => {
    const role = inject(GISGO_AUTH_CONTEXT).role();
    if (role === null) {
      return false;
    }
    return role === 'admin' || allowed.includes(role);
  };
}
